import * as React from "react"
import { cn } from "@/lib/utils"

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps & {
  error?: boolean;
  success?: boolean;
  variant?: 'default' | 'glass';
}>(
  ({ className, type, error, success, variant = 'default', ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border px-3 py-2 text-sm text-arc-text-main placeholder:text-arc-text-muted",
          "transition-all duration-200",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-arc-bg",
          "disabled:cursor-not-allowed disabled:opacity-50",
          variant === 'glass' &&
            !error &&
            !success &&
            "glass-input-cutout border-white/10 bg-transparent hover:border-white/15 focus-visible:border-[var(--arc-cyan-primary)]/50 focus-visible:ring-[var(--arc-cyan-primary)]/40",
          variant === 'default' && "bg-arc-panel",
          error
            ? "border-arc-danger focus-visible:ring-arc-danger focus-visible:border-arc-danger"
            : success
              ? "border-green-500 focus-visible:ring-green-500 focus-visible:border-green-500"
              : variant === 'default' &&
                  "border-arc-border focus-visible:ring-arc-primary focus-visible:border-arc-primary hover:border-arc-primary/50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }

